import { Box } from "@mui/material";
import Translate from "component/global/translation/translation-component";
import AnnouncementSharpIcon from '@mui/icons-material/AnnouncementSharp';

const RecordListNoTableAccessComponent = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", color: "var(--prm-text-secondary)" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <AnnouncementSharpIcon sx={{ fontSize: 54 }} />
            </Box>
            <Translate variant="h6" align="center" text="You don't have access to this table." />
        </Box>
    );
};

export default RecordListNoTableAccessComponent;
